import type { QuizStep } from '../../types';

interface Props {
  step: QuizStep;
  value: string;
  onChange: (value: string) => void;
}

export function InputStep({ step, value, onChange }: Props) {
  return (
    <div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={step.placeholder || 'Type your answer…'}
        className="h-12 w-full rounded-xl border-2 border-border bg-card px-4 text-[15px] text-foreground outline-none transition-colors placeholder:text-muted-foreground focus:border-primary"
        autoFocus
      />
    </div>
  );
}
